import { render, staticRenderFns } from "./shareXkOrder.vue?vue&type=template&id=462063f8"
import script from "./shareXkOrder.vue?vue&type=script&lang=js"
export * from "./shareXkOrder.vue?vue&type=script&lang=js"
import style0 from "./shareXkOrder.vue?vue&type=style&index=0&id=462063f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports